(function() {

  const inputContainers = document.querySelectorAll('.Input');

  for(let i=0; i<inputContainers.length; i++) {

    const input = inputContainers[i].querySelector('.Input-input');
    const elError = inputContainers[i].querySelector('.Input-error');

    if( input ) {
      input.aibError = {
        container: inputContainers[i],
        elError: elError,
        showError: showInputError.bind(input),
        hideError: hideInputError.bind(input),
        toggleError: toggleInputError.bind(input),
        message: '',
      }
      input.addEventListener('change', ()=>{
        input.aibError.toggleError(null, !input.checkValidity() );
      });
    }
  }

  function showInputError() {
    const { container, message, elError } = this.aibError;

    container.classList.add('Input--hasErrors');
    if( message && elError ) {
      elError.innerHTML = message;
    }
  }

  function hideInputError() {
    this.aibError.container.classList.remove('Input--hasErrors');
  }

  function toggleInputError(message, showError = true) {
    if( !!showError ) {
      this.aibError.message = message;
      this.aibError.showError();
    } else {
      this.aibError.hideError();
    }
  }

})();
